module.exports = __webpack_public_path__ + "img/bg.3815bfc5.png";